import { ReadOutlined, ToolOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactNode, useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../auth/user-context";
import { useMobileBreakpoint } from "../../shared/hooks/mobile-hook";
import AuthButtons from "../auth-buttons/auth-buttons";
import "./navbar.scss";

export interface NavbarProps {}
interface IYettyTabs {
  icon: ReactNode;
  text?: string;
  toLink?: string;
}

export const Navbar: React.FC<NavbarProps> = (props) => {
  let location = useLocation();
  const [current, setCurrentMenu] = useState(location.pathname);
  const isMobile = useMobileBreakpoint(() => console.log("mobile vIew"));
  const { user } = useContext(UserContext);

  useEffect(() => {
    setCurrentMenu(location.pathname);
  }, [location]);

  const handleClick = (e: any) => {
    setCurrentMenu(e.key);
  };
  const iconStyle = { fontSize: "1.5rem" };

  const tabs: IYettyTabs[] = [
    {
      icon: <ToolOutlined style={iconStyle} />,
      text: "Write Article",
      toLink: "/write",
    },
    {
      icon: <ReadOutlined style={iconStyle} />,
      text: "Blogs",
      toLink: "/blog",
    },
    // {
    //   icon: <ReadOutlined style={iconStyle} />,
    //   text: "Approve Blogs",
    //   toLink: "/approve",
    // },
  ];

  return (
    <div
      className={`d-flex justify-content-between bg-primary ${
        !isMobile ? "w-75" : "w-100"
      }`}
    >
      <Menu
        onClick={handleClick}
        selectedKeys={[current]}
        mode="horizontal"
        className="d-flex justify-content-around mx-4 bg-primary"
      >
        {tabs.map((tab, i) => (
          <Menu.Item
            key={tab.toLink}
            title={tab.text}
            disabled={tab.toLink === "/write" && !user?.uid}
          >
            {tab.text}
            {tab.toLink ? <Link to={tab.toLink} /> : null}
          </Menu.Item>
        ))}
      </Menu>
      <AuthButtons style={iconStyle} isMobile={isMobile} />
    </div>
  );
};

export default Navbar;
